enum OvhProductName {
  HOSTING = 'Hosting',
  OFFICE365 = 'Office365',
  EXCHANGE = 'Exchange',
  WORDPRESS = 'Wordpress',
  TELECOMETHERNET = 'TelecomEthernet',
  HEADSET = 'Headset',
  TELEPHONY = 'Telephony',
  PROJECTCLOUD = 'ProjectCloud',
  SERVER = 'Server',
  IP = 'IP',
  VPS = 'VPS',
  NUTANIX = 'Nutanix',
  MANAGEDBM = 'ManagedBM',
  VMWARE = 'VmWare',
  NAS = 'NAS',
  VEEAM = 'VEEAM',
  VRACK = 'VRACK',
  LINECOMMUNICATING = 'LineCommunicating',
  BAREMETALCLOUD = 'BareMetalCloud',
  HOSTEDPRIVATECLOUD = 'HostedPrivateCloud',
  NETWORK = 'Network',
  PUBLICCLOUD = 'PublicCloud',
  SECURITYIDENTITYOPERATION = 'SecurityIdentityOperation',
  SUNRISE = 'Sunrise',
  TELECOM = 'Telecom',
  WEBCLOUD = 'Webcloud',
  HELPECENTER = 'Helpe',
  LEAF = 'Leaf',
  LIVECHAT = 'LiveChat',
  NETWORKSTATUS = 'NetworkStatus',
  STORE = 'Store',
  EMAIL = 'Email',
  GLOBE = 'Globe',
  LOCKCLOSE = 'LockClose',
  MONITOR = 'Monitor',
  NETWORKV2 = 'Networkv2',
  PHONE = 'Phone',
  SERVERV2 = 'ServerV2',
  SHIELDCHECK = 'ShieldCheck',
  SHOPPINGCARTPLUS = 'ShoppingCartPlus',
  SPARKLE = 'Sparkle',
  STAR = 'Star',
  CLOUD_CHANGELOG = 'CloudChangelog',
  HOSTING_CHANGELOG = 'HostingChangelog',
  ZIMBRA = 'Zimbra',
  OBSERVABILITY = 'Observability',
  OVH_LOGO = 'OVHLogo',
  OVH_SHORT_LOGO = 'OVHShortLogo',
}

export default OvhProductName;
